import PositiveIcon from '@components/icons/Positive.svg';
import { Link as RouterLink } from 'react-router-dom';

export const ContactSalesSuccess = () => {
  return (
    <div className="mx-auto flex h-[430px] w-full max-w-[640px] flex-col items-center justify-center gap-2.5 rounded-[20px] bg-surface p-[30px] text-center">
      <PositiveIcon className="mb-10 size-[100px]" />
      <h1 className="text-[18px] font-semibold leading-6 text-foreground">Great!</h1>
      <h3 className="text-xs font-medium leading-[18px] text-foreground-muted">Your message is sent.</h3>
      <p className="text-xs font-medium leading-4 text-foreground">
        Now you can{' '}
        <RouterLink to="/" className="text-accent underline">
          go back
        </RouterLink>{' '}
        to the main page.
      </p>
    </div>
  );
};
